import { notification } from 'antd';
import { useCreateAnalysisReportMutation } from '../service';
import { useCallback } from 'react';

export default function useInitializeAnalysis() {
    const [createAnalysisReport] = useCreateAnalysisReportMutation();

    const createMainUrlReport = useCallback(
        async (mainUrl: string, sections?: string[]) => {
            try {
                return await createAnalysisReport({ url: mainUrl, sections: sections }).unwrap();
            } catch (error) {
                notification.error({
                    message: 'Error',
                    description: `We cannot access ${mainUrl} in order to perform our test! Either the site is not online, or our tool is being blocked by your server.`,
                });
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const createCompetitorUrlsReports = useCallback(
        (competitorUrls: string[], sections?: string[]) => {
            return competitorUrls.map(async (url) => {
                try {
                    return await createAnalysisReport({ url, sections }).unwrap();
                } catch (error) {
                    notification.error({
                        message: 'Error',
                        description: `Something went wrong when generating report for ${url}`,
                    });
                }
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const initializeAnalysis = useCallback(
        async (mainUrl: string, competitorUrls?: string[], sections?: string[]) => {
            const mainUrlPromise = createMainUrlReport(mainUrl, sections);
            const competitorsPromises = createCompetitorUrlsReports(competitorUrls || [], sections);

            return await Promise.all([mainUrlPromise, ...competitorsPromises]);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return {
        initializeAnalysis,
    };
}
